import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import "../styles/style_scrollTop.css";

gsap.registerPlugin(ScrollToPlugin);

export default function ScrollTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const btnRef = useRef(null);
  const pluginReady = useRef(false);

  useEffect(() => {
    if (!pluginReady.current) {
      gsap.registerPlugin(ScrollToPlugin);
      pluginReady.current = true;
    }

    const handleScroll = () => {
      const shouldShow = window.scrollY > window.innerHeight;
      setIsVisible(shouldShow);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

    useEffect(() => {
    if (!btnRef.current) return;

    if (isVisible) {
      gsap.fromTo(
        btnRef.current,
        {
          autoAlpha: 0,
          y: 20,
          scale: 0.88,
          filter: "blur(6px)",
        },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          filter: "blur(0px)",
          duration: 0.45,
          ease: "power3.out",
          pointerEvents: "auto",
        }
      );
    } else {
      gsap.to(btnRef.current, {
        autoAlpha: 0,
        y: 12,
        scale: 0.9,
        filter: "blur(4px)",
        duration: 0.28,
        ease: "power2.in",
        pointerEvents: "none",
      });
    }
  }, [isVisible]);

  const scrollToTop = () => {
    const hasScrollTo = Boolean(gsap.plugins?.ScrollToPlugin);

    if (hasScrollTo) {
      gsap.to(window, {
        duration: 0.8,
        scrollTo: { y: 0, autoKill: true },
        ease: "power3.out",
      });
    } else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      ref={btnRef}
      type="button"
      className={`scroll-top-btn ${isVisible ? "visible" : ""}`}
      onClick={scrollToTop}
      aria-label="Remonter en haut de page">
      <div className="scroll-top-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" role="presentation" focusable="false">
          <path d="M12 5l7 7-1.4 1.4L13 9.8V19h-2V9.8l-4.6 4.6L5 12z" />
        </svg>
      </div>
      <span className="scroll-top-text">Haut</span>
    </button>
  );
}